"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAmenityGroupDto = instanceOfAmenityGroupDto;
exports.AmenityGroupDtoFromJSON = AmenityGroupDtoFromJSON;
exports.AmenityGroupDtoFromJSONTyped = AmenityGroupDtoFromJSONTyped;
exports.AmenityGroupDtoToJSON = AmenityGroupDtoToJSON;
exports.AmenityGroupDtoToJSONTyped = AmenityGroupDtoToJSONTyped;
var AmenityDto_1 = require("./AmenityDto");
/**
 * Check if a given object implements the AmenityGroupDto interface.
 */
function instanceOfAmenityGroupDto(value) {
    if (!('category' in value) || value['category'] === undefined)
        return false;
    if (!('amenities' in value) || value['amenities'] === undefined)
        return false;
    return true;
}
function AmenityGroupDtoFromJSON(json) {
    return AmenityGroupDtoFromJSONTyped(json, false);
}
function AmenityGroupDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'category': json['category'],
        'amenities': (json['amenities'].map(AmenityDto_1.AmenityDtoFromJSON)),
    };
}
function AmenityGroupDtoToJSON(json) {
    return AmenityGroupDtoToJSONTyped(json, false);
}
function AmenityGroupDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'category': value['category'],
        'amenities': (value['amenities'].map(AmenityDto_1.AmenityDtoToJSON)),
    };
}
